import { useTranslation } from 'react-i18next'
import useQueryGetMe from '@/api/auth/getMe.ts'

export const useAccountProfile = () => {
    const { t } = useTranslation()
    const { data: me } = useQueryGetMe()
    const name = me?.name || t('topNav.menu.account')
    const initial = name
        .replace(/^\[[^\]]+\]\s*/, '')
        .trim()
        .charAt(0)
        .toUpperCase() || 'C'

    return { name, email: me?.email, initial }
}
